var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-bar',{staticClass:"app-appbar fill-height"}),_c('nav-drawer',{staticClass:"app-sidebar"}),_c('v-container',{staticClass:"pa-2 app-container",attrs:{"fluid":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }